import React from 'react';
import { styled } from 'linaria/react';
import {
	Container,
	ModalContainer,
	PageBreadcrumbs,
	PageTitle,
	SEOProductSchema,
	StoreSelectionModal,
} from 'common/components';
import { PageTitleMargin } from '../../styles';
import { BrandAttributes } from './brand-attributes';
import { useInstoreService } from '../../hooks';
import { useInstore } from '../../../hooks';
import { OtherCategories } from '../other-categories';
import { Caption } from '../texts';
import { ServicesRepresentation } from './services-representation';
import { CurtainsKinds } from './curtains-kinds';
import { HowToOrder } from './how-to-order';
import { Faq } from './faq';

const Wrapper = styled.div`
	display: grid;
`;

export const PoshivShtor = () => {
	const { isModalOpen, openModal, closeModal, selectedStoreCode, stores } = useInstore();
	const { pageTexts } = useInstoreService();
	const { caption } = pageTexts;

	return (
		<section data-qa="instore-service-poshiv-shtor-page">
			<Container>
				<PageBreadcrumbs />
				<Wrapper data-qa="wrapper">
					<PageTitle className={PageTitleMargin} />
					<ServicesRepresentation />
					<BrandAttributes openStoreSelectionModal={openModal} />
					<CurtainsKinds openStoreSelectionModal={openModal} />
					<HowToOrder openStoreSelectionModal={openModal} />
					<Faq />
					<Caption text={caption} />
				</Wrapper>
			</Container>
			<OtherCategories />
			<ModalContainer isOpen={isModalOpen} onClose={closeModal} variant="curtain">
				<StoreSelectionModal
					selectedStoreCode={selectedStoreCode}
					storesList={stores}
					target="_blank"
				/>
			</ModalContainer>
			<SEOProductSchema />
		</section>
	);
};
